export default {
  inProgress: 'components.views.sign-up-view.account-confirmed.in-progress',
  confirmed: 'components.views.sign-up-view.account-confirmed.confirmed',
  failed: 'components.views.sign-up-view.account-confirmed.failed',
  allowLogin: 'components.views.sign-up-view.account-confirmed.allow-login',
  error: 'components.views.sign-up-view.account-confirmed.error'
}
